var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: "a-subscriber-container columns mx-2 " + _vm.hasSubscriptionClass
    },
    [
      _c("settings-sidebar", {
        staticClass: "column is-3 py-2 mr-md-3 mb-3 mb-md-auto",
        attrs: { "active-menu-item": "advertisement" }
      }),
      _vm._v(" "),
      _vm.userSubscriptions.length
        ? _c(
            "div",
            {
              staticClass:
                "container-lg column is-multiline m-0  mt-sm-4 mt-md-3 mt-lg-0 p-0"
            },
            [
              _c("dropzone"),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    {
                      staticClass:
                        "bg-white mt-3 py-4 pl-4 pr-md-16 pr-4 border-radius"
                    },
                    [
                      _c("h1", { staticClass: "mb-3 fs-28" }, [
                        _vm._v("Your advert subscription")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-4" }, [
                        _vm._v(
                          "You can cancel your advertisement subscription at anytime but please be aware that as soon as your subscription\n                is cancelled your advert will be removed from the website immediately regardless of where you are in the current\n                billing cycle."
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.loading
                        ? _c(
                            "a",
                            {
                              staticClass:
                                "cancel-subscription font-weight-bold fs-18",
                              on: { click: _vm.cancel }
                            },
                            [_vm._v("Cancel subscription")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.loading
                        ? _c("pulse-loader", {
                            attrs: {
                              loading: true,
                              color: "#143642",
                              size: "10px"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c("cat-uxo-advertisement", {
            attrs: { "active-users": _vm.activeUsers, plans: _vm.plans }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4191f76f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4191f76f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Advertisement.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4191f76f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/pages/settings/Advertisement.vue
// module chunks = 0 1